import React, { useState } from 'react';
import dictionary from '../../utils/dictionary';
import AlertError from '../Common/AlertError';
import TextInput from '../Common/TextInput';
import ActivityLoader from '../Common/ActivityLoader';

const PopCreateClampAbortReason = (props) => {

    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState("");
    const [info, setInfo] = useState(false);

    const onConfirm = (event) => {
        event.preventDefault();
        if (reason.length > 0) {
            setLoading(true);
            props.onConfirm(reason);
        } else {

            setInfo(<AlertError message={"Enter Abort Reason and try again"} />)

        }
    }

    return (
        <div className="modal" id="modal_new_clamp_abort_reason">
            <div className="modal-dialog modal-dialog-centered" role="document">


                <div className="modal-content modal-content-demo shadow">
                    <div className="modal-header">
                        <h6 className="modal-title">Create Clamp Abort Reason</h6>
                        <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div className="modal-body">
                        {info}
                        <form method="post" onSubmit={onConfirm}>

                            <TextInput
                                label="Abort Reason"
                                type="text"
                                onChange={(e) => setReason(e.target.value)}
                                value={reason}
                                name="abortReason"
                            />

                        </form>


                    </div>
                    <div className="modal-footer">
                        {!loading && <>
                            <button className="btn ripple btn-primary" type="button" onClick={onConfirm}>Save Violation</button>
                            <button className="btn ripple btn-light" type="button" data-dismiss="modal">Close</button>
                        </>}
                        {loading && <ActivityLoader />}
                    </div>
                </div>


            </div>
        </div>
    )


}


export default PopCreateClampAbortReason;
